





























































import { Component, Prop, Vue } from "vue-property-decorator";
import AttachmentUploader from "./AttachmentUploader.vue";
import Attachment from "../models/Attachment";
import { AttachmentTypes } from "../Constants";

@Component({
  components: {
    AttachmentUploader
  }
})
export default class SubmissionFormAttachments extends Vue {
  @Prop() private attachments!: Array<Attachment>;
  private maxAttachments = 7;
  private attachmentTypes = AttachmentTypes.ALL;

  addAttachment() {
    this.attachments.push(new Attachment());
  }

  removeAttachment(index: number) {
    this.attachments.splice(index, 1);
  }

  get tooManyAttachments(): boolean {
    return this.attachments.length >= this.maxAttachments;
  }
}
